import { FlowConfig, FlowsInterface, InputDict } from "../types/Flows";
import { apiUrls } from "./apiUrls";
import { makeRequest } from "./request";

class Flows implements FlowsInterface {
  readonly apiKey: string;

  constructor(apiKey: string) {
    this.apiKey = apiKey;
  }

  async execute_flow(
    authorName: string,
    flowName: string,
    inputDict: InputDict,
    version: string
  ): Promise<any> {
    const path = apiUrls.flows.execute(authorName, flowName);
    const params = {
      version,
    };
    try {
      return await makeRequest("POST", path, this.apiKey, params, inputDict);
    } catch (error) {
      console.error("Error executing flow:", error);
    }
  }

  async run_flow(flowConfig: FlowConfig, inputDict: InputDict): Promise<any> {
    const path = apiUrls.flows.run;
    const jsonData = {
      flow_config: flowConfig,
      input: inputDict,
    };
    try {
      return await makeRequest("POST", path, this.apiKey, {}, jsonData);
    } catch (error) {
      console.error("Error running flow:", error);
    }
  }

  async get_flow(
    authorName: string,
    flowName: string,
    version: string
  ): Promise<any> {
    const path = apiUrls.flows.get(authorName, flowName);
    const params = {
      version,
    };
    try {
      const response = await makeRequest("GET", path, this.apiKey, params);
      return response.data;
    } catch (error) {
      console.error("Error fetching flow:", error);
    }
  }

  async get_flows_by_author(authorName: string): Promise<any> {
    const path = apiUrls.flows.byAuthor(authorName);
    try {
      const response = await makeRequest("GET", path, this.apiKey);
      return response.data;
    } catch (error) {
      console.error("Error fetching flows by author:", error);
    }
  }

  async deploy_flow(
    authorName: string,
    flowName: string,
    flowConfig: FlowConfig,
    isPrivate: boolean,
    version?: string
  ): Promise<any> {
    const path = apiUrls.flows.deploy(authorName, flowName);
    const jsonData = {
      flow: flowConfig,
      private: isPrivate,
    };
    const params: Record<string, string> = version ? { version } : {};
    try {
      return await makeRequest("POST", path, this.apiKey, params, jsonData);
    } catch (error) {
      console.error("Error deploying flow:", error);
    }
  }
}

export default Flows;
